import MkuForm from './src/form';

MkuForm.install = function (Vue) {
  Vue.component(MkuForm.name, MkuForm);
};

export default MkuForm;
